import React, { FC } from 'react';

import { customMailSending } from 'modules/custom-mail/action';
import { useAppDispatch } from 'modules/store';
import { AlertModal } from 'shared-components';

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
  recipients: string[];
  clearSelectedResults: () => void;
  subject: string;
  content: string;
  entity?: string;
  ids: number[];
};

const MailingConfirmationModal: FC<Props> = ({
  isOpen,
  onClose,
  recipients,
  clearSelectedResults,
  subject,
  content,
  entity,
  ids,
}) => {
  const dispatch = useAppDispatch();

  const onSubmitDelete = () => {
    dispatch(customMailSending({ subject: subject, body: content, ids: ids, type: 'batch', entity: entity ?? '' }))
      .unwrap()
      .then(clearSelectedResults)
      .finally(() => {
        onClose();
      });
  };

  return (
    <AlertModal
      secondModal
      isLoading={false}
      onSubmit={() => onSubmitDelete()}
      onClose={onClose}
      isOpen={isOpen}
      title={'Are you sure you want to send an email to:'}
      backButtonText='No'
      submitButtonText='Yes'
      wrapperModalClassName='lg:px-4 2xl:px-14'
    >
      <div className='py-12'>{recipients.join(', ')}</div>
    </AlertModal>
  );
};

export default MailingConfirmationModal;
